import React, {useEffect, useMemo} from 'react';
import WalletDownloadSnippet from "../WalletDownload/WalletDownloadSnippet";
import {LoginType, SnippetTheme, SnippetType, WebSnippetProfile} from "../Helpers/Types";
import {SnippetProvider} from "../Utils/UseSnippetContext";

type WalletDownloadTestSnippetProps = {}

export default function WalletDownloadTestSnippet(props: WalletDownloadTestSnippetProps) {
    const queryString = require('query-string');
    const parsed = queryString.parse(window.location.search);
    const loginDomain = (parsed.bl_logindomain as string) || 'client';
    const deviceCode = (parsed.bl_devicecode as string) || 'S139-1';

    const testProfile: WebSnippetProfile = useMemo(() => ({
        Uid: '',
        ExternalId: '',
        Code: 'walletdownloadtest',
        Name: 'Wallet Download Test',
        Type: SnippetType.WalletDownload,
        IsValid: true,
        Theme: SnippetTheme.Default,
        LogoUrl: '',
        Title: 'Your Offers',
        Message: 'Download your wallet pass to access these offers in-store.',
        Footer: 'Powered by bLoyal',
        OnSuccessRedirectUrl: '',
        OnSuccessMessage: 'Pass added to wallet. You can close this page.',
        OnSuccessRedirectDelay: 0,
        OnErrorRedirectUrl: '',
        OnErrorMessage: 'Unable to add to wallet. Please try again later.',
        OnErrorRedirectDelay: 0,
        LoginType: LoginType.NotRequired,
        LoginSnippetCode: '',
        LoginUrl: '',
        Buttons: [],
        WalletDownload: {
            AutoDetectAndDownload: false,
            EnableAppleWallet: true,
            EnableGoogleWallet: true,
            AppleLinkName: 'Add to Apple Wallet',
            AppleLinkDescription: 'Save this pass to your Apple Wallet',
            GoogleLinkName: 'Add to Google Wallet',
            GoogleLinkDescription: 'Save this pass to your Google Wallet',
            DisplayQRCode: true
        },
        // @ts-ignore Intentionally omit other snippet profiles for this local test
        ClubSignup: null
    } as any), []);

    useEffect(() => {
        // Provide example coupons to mirror the screenshot design
        const sampleCoupons = [
            { Name: '20% Off Any Apparel', Description: 'Take 20% off apparel. Excludes clearance and gift cards. Expires Nov 15,2025.'},
            { Name: '30% Off on Sunglasses', Description: 'Take 30% off sunglasses. Excludes clearance and gift cards. Expires Nov 15,2025.'}
        ];
        // @ts-ignore
        window.dispatchEvent(new CustomEvent('bl:setWalletCoupons', { detail: sampleCoupons }));
    }, []);

    return (
        <SnippetProvider domain={loginDomain} deviceCode={deviceCode}
                         clubCode={''} useLogout={false}
                         returnUrlParam={'ReturnUrl'} loginUrl={''}>
            <div className='bLoyal-snippet-container' style={{padding: '0 10px'}}>
                <WalletDownloadSnippet snippetProfile={testProfile} />
            </div>
        </SnippetProvider>
    )
}


